var _a, _b, _c, _d, _e, _f;
import { DeloitteIndustryApi, DeloitteOfferingApi, DeloitteOfferingPortfolioApi, DeloittePracticeApi, DeloitteProjectTypeApi, } from 'api-typings/projects/deloitte';
// @see {@link https://phabricator.tools.flnltd.com/D125102|Deloitte billing code regex}
export var deloitteBillingCodeMatcher = /([A-Z]{3}[\d]{5})-?([A-Z\d]{2})-?([A-Z\d]{2})-?([A-Z\d]{2})-?([\d]{4})/;
export var deloitteBillingCodePattern = /^[A-Z]{3}[\d]{5}-?[A-Z\d]{2}-?[A-Z\d]{2}-?[A-Z\d]{2}-?[\d]{4}$/i;
export var DELOITTE_PROJECT_TYPE_DISPLAY_NAME_MAP = (_a = {},
    _a[DeloitteProjectTypeApi.CLIENT_BILLABLE] = 'Client Billable',
    _a[DeloitteProjectTypeApi.FIRM_INITIATIVE] = 'Firm Initiative',
    _a[DeloitteProjectTypeApi.PRD] = 'PRD',
    _a[DeloitteProjectTypeApi.OTHER_INVESTMENT] = 'Other Investments',
    _a);
export var DELOITTE_PRACTICE_DISPLAY_NAME_MAP = (_b = {},
    _b[DeloittePracticeApi.COMMERCIAL_CORE] = 'Commercial Core',
    _b[DeloittePracticeApi.COMMERCIAL_USDC_ONSITE] = 'Commercial USDC Onsite',
    _b[DeloittePracticeApi.COMMERCIAL_USDC_INCENTER] = 'Commercial USDC In-Center',
    _b[DeloittePracticeApi.GPS_CORE] = 'GPS Core',
    _b[DeloittePracticeApi.GPS_USDC_ONSITE] = 'GPS USDC Onsite',
    _b[DeloittePracticeApi.GPS_USDC_INCENTER] = 'GPS USDC In-Center',
    _b[DeloittePracticeApi.USI_ONSITE] = 'USI Onsite',
    _b[DeloittePracticeApi.USI_OFFSHORE] = 'USI Offshore',
    _b);
export var DELOITTE_INDUSTRY_DISPLAY_NAME_MAP = (_c = {},
    _c[DeloitteIndustryApi.AUTOMOTIVE] = 'Automative',
    _c[DeloitteIndustryApi.BANKING_AND_CAPITAL_MARKETS] = 'Banking & Capital Markets',
    _c[DeloitteIndustryApi.CIVIL_GOVERNMENT] = 'Civil Government',
    _c[DeloitteIndustryApi.CONSUMER_PRODUCTS] = 'Consumer Products',
    _c[DeloitteIndustryApi.CROSS_SECTOR_C] = 'Cross Sector (C)',
    _c[DeloitteIndustryApi.CROSS_SECTOR_CI] = 'Cross Sector (CI)',
    _c[DeloitteIndustryApi.CROSS_SECTOR_ERI] = 'Cross Sector (ERI)',
    _c[DeloitteIndustryApi.CROSS_SECTOR_FS] = 'Cross Sector (FS)',
    _c[DeloitteIndustryApi.CROSS_SECTOR_GPS] = 'Cross Sector (GPS)',
    _c[DeloitteIndustryApi.CROSS_SECTOR_LSHC] = 'Cross Sector (LSHC)',
    _c[DeloitteIndustryApi.CROSS_SECTOR_TMT] = 'Cross Sector (TMT)',
    _c[DeloitteIndustryApi.DEFENSE_SECURITY_AND_JUSTICE] = 'Defense Security & Justice',
    _c[DeloitteIndustryApi.FEDERAL_HEALTH] = 'Federal Health',
    _c[DeloitteIndustryApi.HEALTH_CARE] = 'Health Care',
    _c[DeloitteIndustryApi.INDUSTRIAL_PRODUCTS_AND_CONSTRUCTION] = 'Industrial Products & Construction',
    _c[DeloitteIndustryApi.INSURANCE] = 'Insurance',
    _c[DeloitteIndustryApi.INVESTMENT_MANAGEMENT] = 'Investment Management',
    _c[DeloitteIndustryApi.MEDIA_AND_ENTERTAINMENT] = 'Media & Entertainment',
    _c[DeloitteIndustryApi.OIL_GAS_AND_CHEMICALS] = 'Oil, Gas, & Chemicals',
    _c[DeloitteIndustryApi.POWER_AND_UTILITIES] = 'Power & Utilities',
    _c[DeloitteIndustryApi.REAL_ESTATE] = 'Real Estate',
    _c[DeloitteIndustryApi.RETAIL_WHOLESALE_AND_DISTRIBUTION] = 'Retail, Wholesale, & Distribution',
    _c[DeloitteIndustryApi.STATE_LOCAL_AND_HIGHER_EDUCATION] = 'State, Local, & Higher Education',
    _c[DeloitteIndustryApi.TECHNOLOGY] = 'Technology',
    _c[DeloitteIndustryApi.TRANSPORTATION_HOSPITALITY_AND_SERVICES] = 'Transportation, Hospitality, & Services',
    _c);
export var DELOITTE_OFFERING_DISPLAY_NAME_MAP = (_d = {},
    _d[DeloitteOfferingApi.CBO_CROSS_CONSULTING_GROUP] = 'Cross Consulting Group',
    _d[DeloitteOfferingApi.CBO_OPERATIONS_TRANSFORMATION] = 'Operations Transformation',
    _d[DeloitteOfferingApi.CBO_SYSTEMS_ENGINEERING] = 'Systems Engineering',
    _d[DeloitteOfferingApi.CBO_CLOUD_ENGINEERING] = 'Cloud Engineering',
    _d[DeloitteOfferingApi.CBO_CORE_INDUSTRY_SOLUTIONS] = 'Core Industry Solutions',
    _d[DeloitteOfferingApi.CBO_HEALTH_TECHNOLOGY] = 'Health Technology',
    _d[DeloitteOfferingApi.CNM_CUSTOMER_STRATEGY_AND_APPLIED_DESIGN] = 'Customer Strategy & Applied Design',
    _d[DeloitteOfferingApi.CNM_ADVERTISING_MARKETING_AND_COMMERCE] = 'Advertising, Marketing, & Commerce',
    _d[DeloitteOfferingApi.CNM_DIGITAL_CUSTOMER] = 'Digital Customer',
    _d[DeloitteOfferingApi.CNM_HUMAN_SERVICES_TRANSFORMATION] = 'Human Services Transformation',
    _d[DeloitteOfferingApi.CNM_DIGITAL_GOVERNMENT] = 'Digital Government',
    _d[DeloitteOfferingApi.CNM_CROSS_CONSULTING_GROUP] = 'Cross Consulting Group',
    _d[DeloitteOfferingApi.EO_CROSS_CONSULTING_GROUP] = 'Cross Consulting Group',
    _d[DeloitteOfferingApi.EO_FINANCE_AND_ENTERPRISE_PERFORMANCE] = 'Finance & Enterprise Performance',
    _d[DeloitteOfferingApi.EO_SUPPLY_CHAIN_AND_NETWORK_OPERATIONS] = 'Supply Chain & Network Operations',
    _d[DeloitteOfferingApi.EO_TECHNOLOGY_SERVICES_OPTIMIZATION] = 'Technology Services Optimization',
    _d[DeloitteOfferingApi.EO_SAP] = 'SAP',
    _d[DeloitteOfferingApi.EO_ORACLE] = 'Oracle',
    _d[DeloitteOfferingApi.EO_ERP_SAAS] = 'ERP SaaS',
    _d[DeloitteOfferingApi.HC_CROSS_CONSULTING_GROUP] = 'Cross Consulting Group',
    _d[DeloitteOfferingApi.HC_HR_TRANSFORMATION] = 'HR Transformation',
    _d[DeloitteOfferingApi.HC_ORGANIZATION_TRANSFORMATION] = 'Organization Transformation',
    _d[DeloitteOfferingApi.HC_WORKFORCE_TRANSFORMATION] = 'Workforce Transformation',
    _d[DeloitteOfferingApi.HC_HC_AS_A_SERVICE] = 'HC as a Service',
    _d[DeloitteOfferingApi.MNA_MERGERS_AND_ACQUISITIONS] = 'Mergers & Acquisitions',
    _d[DeloitteOfferingApi.SNA_CROSS_CONSULTING_GROUP] = 'Cross Consulting Group',
    _d[DeloitteOfferingApi.SNA_STRATEGY] = 'Strategy',
    _d[DeloitteOfferingApi.SNA_ANALYTICS_AND_COGNITIVE] = 'Analytics & Cognitive',
    _d[DeloitteOfferingApi.SNA_HYBRID_SOLUTIONS_AND_INCUBATION] = 'Hybrid Solutions & Incubation',
    _d);
export var DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP = (_e = {},
    _e[DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS] = 'Core Business Operations',
    _e[DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING] = 'Customer & Marketing',
    _e[DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS] = 'Enterprise Operations',
    _e[DeloitteOfferingPortfolioApi.HUMAN_CAPITAL] = 'Human Capital',
    _e[DeloitteOfferingPortfolioApi.MERGERS_AND_ACQUISITIONS] = 'Mergers & Acquisitions',
    _e[DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS] = 'Strategy & Analytics',
    _e);
export var DELOITTE_OFFERING_FULL_DISPLAY_NAME_MAP = (_f = {},
    _f[DeloitteOfferingApi.CBO_CROSS_CONSULTING_GROUP] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_CROSS_CONSULTING_GROUP],
    _f[DeloitteOfferingApi.CBO_OPERATIONS_TRANSFORMATION] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_OPERATIONS_TRANSFORMATION],
    _f[DeloitteOfferingApi.CBO_SYSTEMS_ENGINEERING] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_SYSTEMS_ENGINEERING],
    _f[DeloitteOfferingApi.CBO_CLOUD_ENGINEERING] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_CLOUD_ENGINEERING],
    _f[DeloitteOfferingApi.CBO_CORE_INDUSTRY_SOLUTIONS] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_CORE_INDUSTRY_SOLUTIONS],
    _f[DeloitteOfferingApi.CBO_HEALTH_TECHNOLOGY] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_HEALTH_TECHNOLOGY],
    _f[DeloitteOfferingApi.CNM_CUSTOMER_STRATEGY_AND_APPLIED_DESIGN] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_CUSTOMER_STRATEGY_AND_APPLIED_DESIGN],
    _f[DeloitteOfferingApi.CNM_ADVERTISING_MARKETING_AND_COMMERCE] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_ADVERTISING_MARKETING_AND_COMMERCE],
    _f[DeloitteOfferingApi.CNM_DIGITAL_CUSTOMER] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_DIGITAL_CUSTOMER],
    _f[DeloitteOfferingApi.CNM_HUMAN_SERVICES_TRANSFORMATION] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_HUMAN_SERVICES_TRANSFORMATION],
    _f[DeloitteOfferingApi.CNM_DIGITAL_GOVERNMENT] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_DIGITAL_GOVERNMENT],
    _f[DeloitteOfferingApi.CNM_CROSS_CONSULTING_GROUP] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_CROSS_CONSULTING_GROUP],
    _f[DeloitteOfferingApi.EO_CROSS_CONSULTING_GROUP] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_CROSS_CONSULTING_GROUP],
    _f[DeloitteOfferingApi.EO_FINANCE_AND_ENTERPRISE_PERFORMANCE] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_FINANCE_AND_ENTERPRISE_PERFORMANCE],
    _f[DeloitteOfferingApi.EO_SUPPLY_CHAIN_AND_NETWORK_OPERATIONS] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_SUPPLY_CHAIN_AND_NETWORK_OPERATIONS],
    _f[DeloitteOfferingApi.EO_TECHNOLOGY_SERVICES_OPTIMIZATION] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_TECHNOLOGY_SERVICES_OPTIMIZATION],
    _f[DeloitteOfferingApi.EO_SAP] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_SAP],
    _f[DeloitteOfferingApi.EO_ORACLE] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_ORACLE],
    _f[DeloitteOfferingApi.EO_ERP_SAAS] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_ERP_SAAS],
    _f[DeloitteOfferingApi.HC_CROSS_CONSULTING_GROUP] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.HUMAN_CAPITAL] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_CROSS_CONSULTING_GROUP],
    _f[DeloitteOfferingApi.HC_HR_TRANSFORMATION] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.HUMAN_CAPITAL] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_HR_TRANSFORMATION],
    _f[DeloitteOfferingApi.HC_ORGANIZATION_TRANSFORMATION] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.HUMAN_CAPITAL] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_ORGANIZATION_TRANSFORMATION],
    _f[DeloitteOfferingApi.HC_WORKFORCE_TRANSFORMATION] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.HUMAN_CAPITAL] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_WORKFORCE_TRANSFORMATION],
    _f[DeloitteOfferingApi.HC_HC_AS_A_SERVICE] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.HUMAN_CAPITAL] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_HC_AS_A_SERVICE],
    _f[DeloitteOfferingApi.MNA_MERGERS_AND_ACQUISITIONS] = "" + DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.MERGERS_AND_ACQUISITIONS],
    _f[DeloitteOfferingApi.SNA_CROSS_CONSULTING_GROUP] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.SNA_CROSS_CONSULTING_GROUP],
    _f[DeloitteOfferingApi.SNA_STRATEGY] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.SNA_STRATEGY],
    _f[DeloitteOfferingApi.SNA_ANALYTICS_AND_COGNITIVE] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.SNA_ANALYTICS_AND_COGNITIVE],
    _f[DeloitteOfferingApi.SNA_HYBRID_SOLUTIONS_AND_INCUBATION] = DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS] + ", " + DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.SNA_HYBRID_SOLUTIONS_AND_INCUBATION],
    _f);
export var PROJECT_TYPE_OPTIONS = [
    {
        displayText: '',
        value: '',
        disabled: true,
    },
    {
        displayText: DELOITTE_PROJECT_TYPE_DISPLAY_NAME_MAP[DeloitteProjectTypeApi.CLIENT_BILLABLE],
        value: DeloitteProjectTypeApi.CLIENT_BILLABLE,
    },
    {
        displayText: DELOITTE_PROJECT_TYPE_DISPLAY_NAME_MAP[DeloitteProjectTypeApi.FIRM_INITIATIVE],
        value: DeloitteProjectTypeApi.FIRM_INITIATIVE,
    },
    {
        displayText: DELOITTE_PROJECT_TYPE_DISPLAY_NAME_MAP[DeloitteProjectTypeApi.PRD],
        value: DeloitteProjectTypeApi.PRD,
    },
    {
        displayText: DELOITTE_PROJECT_TYPE_DISPLAY_NAME_MAP[DeloitteProjectTypeApi.OTHER_INVESTMENT],
        value: DeloitteProjectTypeApi.OTHER_INVESTMENT,
    },
];
export var PRACTICE_OPTIONS = [
    {
        displayText: '',
        value: '',
        disabled: true,
    },
    {
        displayText: DELOITTE_PRACTICE_DISPLAY_NAME_MAP[DeloittePracticeApi.COMMERCIAL_CORE],
        value: DeloittePracticeApi.COMMERCIAL_CORE,
    },
    {
        displayText: DELOITTE_PRACTICE_DISPLAY_NAME_MAP[DeloittePracticeApi.COMMERCIAL_USDC_INCENTER],
        value: DeloittePracticeApi.COMMERCIAL_USDC_INCENTER,
    },
    {
        displayText: DELOITTE_PRACTICE_DISPLAY_NAME_MAP[DeloittePracticeApi.COMMERCIAL_USDC_ONSITE],
        value: DeloittePracticeApi.COMMERCIAL_USDC_ONSITE,
    },
    {
        displayText: DELOITTE_PRACTICE_DISPLAY_NAME_MAP[DeloittePracticeApi.GPS_CORE],
        value: DeloittePracticeApi.GPS_CORE,
    },
    {
        displayText: DELOITTE_PRACTICE_DISPLAY_NAME_MAP[DeloittePracticeApi.GPS_USDC_INCENTER],
        value: DeloittePracticeApi.GPS_USDC_INCENTER,
    },
    {
        displayText: DELOITTE_PRACTICE_DISPLAY_NAME_MAP[DeloittePracticeApi.GPS_USDC_ONSITE],
        value: DeloittePracticeApi.GPS_USDC_ONSITE,
    },
    {
        displayText: DELOITTE_PRACTICE_DISPLAY_NAME_MAP[DeloittePracticeApi.USI_ONSITE],
        value: DeloittePracticeApi.USI_ONSITE,
    },
    {
        displayText: DELOITTE_PRACTICE_DISPLAY_NAME_MAP[DeloittePracticeApi.USI_OFFSHORE],
        value: DeloittePracticeApi.USI_OFFSHORE,
    },
];
export var INDUSTRY_OPTIONS = [
    {
        displayText: '',
        value: '',
        disabled: true,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.AUTOMOTIVE],
        value: DeloitteIndustryApi.AUTOMOTIVE,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.BANKING_AND_CAPITAL_MARKETS],
        value: DeloitteIndustryApi.BANKING_AND_CAPITAL_MARKETS,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.CIVIL_GOVERNMENT],
        value: DeloitteIndustryApi.CIVIL_GOVERNMENT,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.CONSUMER_PRODUCTS],
        value: DeloitteIndustryApi.CONSUMER_PRODUCTS,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.CROSS_SECTOR_C],
        value: DeloitteIndustryApi.CROSS_SECTOR_C,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.CROSS_SECTOR_CI],
        value: DeloitteIndustryApi.CROSS_SECTOR_CI,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.CROSS_SECTOR_ERI],
        value: DeloitteIndustryApi.CROSS_SECTOR_ERI,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.CROSS_SECTOR_FS],
        value: DeloitteIndustryApi.CROSS_SECTOR_FS,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.CROSS_SECTOR_GPS],
        value: DeloitteIndustryApi.CROSS_SECTOR_GPS,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.CROSS_SECTOR_LSHC],
        value: DeloitteIndustryApi.CROSS_SECTOR_LSHC,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.CROSS_SECTOR_TMT],
        value: DeloitteIndustryApi.CROSS_SECTOR_TMT,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.DEFENSE_SECURITY_AND_JUSTICE],
        value: DeloitteIndustryApi.DEFENSE_SECURITY_AND_JUSTICE,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.FEDERAL_HEALTH],
        value: DeloitteIndustryApi.FEDERAL_HEALTH,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.HEALTH_CARE],
        value: DeloitteIndustryApi.HEALTH_CARE,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.INDUSTRIAL_PRODUCTS_AND_CONSTRUCTION],
        value: DeloitteIndustryApi.INDUSTRIAL_PRODUCTS_AND_CONSTRUCTION,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.INSURANCE],
        value: DeloitteIndustryApi.INSURANCE,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.INVESTMENT_MANAGEMENT],
        value: DeloitteIndustryApi.INVESTMENT_MANAGEMENT,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.MEDIA_AND_ENTERTAINMENT],
        value: DeloitteIndustryApi.MEDIA_AND_ENTERTAINMENT,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.OIL_GAS_AND_CHEMICALS],
        value: DeloitteIndustryApi.OIL_GAS_AND_CHEMICALS,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.POWER_AND_UTILITIES],
        value: DeloitteIndustryApi.POWER_AND_UTILITIES,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.REAL_ESTATE],
        value: DeloitteIndustryApi.REAL_ESTATE,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.RETAIL_WHOLESALE_AND_DISTRIBUTION],
        value: DeloitteIndustryApi.RETAIL_WHOLESALE_AND_DISTRIBUTION,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.STATE_LOCAL_AND_HIGHER_EDUCATION],
        value: DeloitteIndustryApi.STATE_LOCAL_AND_HIGHER_EDUCATION,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.TECHNOLOGY],
        value: DeloitteIndustryApi.TECHNOLOGY,
    },
    {
        displayText: DELOITTE_INDUSTRY_DISPLAY_NAME_MAP[DeloitteIndustryApi.TRANSPORTATION_HOSPITALITY_AND_SERVICES],
        value: DeloitteIndustryApi.TRANSPORTATION_HOSPITALITY_AND_SERVICES,
    },
];
export var OFFERING_OPTIONS = [
    {
        displayText: '',
        value: '',
        disabled: true,
    },
    {
        groupName: DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS],
        options: [
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_CLOUD_ENGINEERING],
                value: DeloitteOfferingApi.CBO_CLOUD_ENGINEERING,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_CORE_INDUSTRY_SOLUTIONS],
                value: DeloitteOfferingApi.CBO_CORE_INDUSTRY_SOLUTIONS,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_CROSS_CONSULTING_GROUP],
                value: DeloitteOfferingApi.CBO_CROSS_CONSULTING_GROUP,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_HEALTH_TECHNOLOGY],
                value: DeloitteOfferingApi.CBO_HEALTH_TECHNOLOGY,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_OPERATIONS_TRANSFORMATION],
                value: DeloitteOfferingApi.CBO_OPERATIONS_TRANSFORMATION,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CBO_SYSTEMS_ENGINEERING],
                value: DeloitteOfferingApi.CBO_SYSTEMS_ENGINEERING,
            },
        ],
    },
    {
        groupName: DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING],
        options: [
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_ADVERTISING_MARKETING_AND_COMMERCE],
                value: DeloitteOfferingApi.CNM_ADVERTISING_MARKETING_AND_COMMERCE,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_CROSS_CONSULTING_GROUP],
                value: DeloitteOfferingApi.CNM_CROSS_CONSULTING_GROUP,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_CUSTOMER_STRATEGY_AND_APPLIED_DESIGN],
                value: DeloitteOfferingApi.CNM_CUSTOMER_STRATEGY_AND_APPLIED_DESIGN,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_DIGITAL_CUSTOMER],
                value: DeloitteOfferingApi.CNM_DIGITAL_CUSTOMER,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_DIGITAL_GOVERNMENT],
                value: DeloitteOfferingApi.CNM_DIGITAL_GOVERNMENT,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.CNM_HUMAN_SERVICES_TRANSFORMATION],
                value: DeloitteOfferingApi.CNM_HUMAN_SERVICES_TRANSFORMATION,
            },
        ],
    },
    {
        groupName: DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS],
        options: [
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_CROSS_CONSULTING_GROUP],
                value: DeloitteOfferingApi.EO_CROSS_CONSULTING_GROUP,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_ERP_SAAS],
                value: DeloitteOfferingApi.EO_ERP_SAAS,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_FINANCE_AND_ENTERPRISE_PERFORMANCE],
                value: DeloitteOfferingApi.EO_FINANCE_AND_ENTERPRISE_PERFORMANCE,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_ORACLE],
                value: DeloitteOfferingApi.EO_ORACLE,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_SAP],
                value: DeloitteOfferingApi.EO_SAP,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_SUPPLY_CHAIN_AND_NETWORK_OPERATIONS],
                value: DeloitteOfferingApi.EO_SUPPLY_CHAIN_AND_NETWORK_OPERATIONS,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.EO_TECHNOLOGY_SERVICES_OPTIMIZATION],
                value: DeloitteOfferingApi.EO_TECHNOLOGY_SERVICES_OPTIMIZATION,
            },
        ],
    },
    {
        groupName: DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.HUMAN_CAPITAL],
        options: [
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_CROSS_CONSULTING_GROUP],
                value: DeloitteOfferingApi.HC_CROSS_CONSULTING_GROUP,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_HC_AS_A_SERVICE],
                value: DeloitteOfferingApi.HC_HC_AS_A_SERVICE,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_HR_TRANSFORMATION],
                value: DeloitteOfferingApi.HC_HR_TRANSFORMATION,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_ORGANIZATION_TRANSFORMATION],
                value: DeloitteOfferingApi.HC_ORGANIZATION_TRANSFORMATION,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.HC_WORKFORCE_TRANSFORMATION],
                value: DeloitteOfferingApi.HC_WORKFORCE_TRANSFORMATION,
            },
        ],
    },
    {
        groupName: DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.MERGERS_AND_ACQUISITIONS],
        options: [
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.MNA_MERGERS_AND_ACQUISITIONS],
                value: DeloitteOfferingApi.MNA_MERGERS_AND_ACQUISITIONS,
            },
        ],
    },
    {
        groupName: DELOITTE_OFFERING_PORTFOLIO_DISPLAY_NAME_MAP[DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS],
        options: [
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.SNA_ANALYTICS_AND_COGNITIVE],
                value: DeloitteOfferingApi.SNA_ANALYTICS_AND_COGNITIVE,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.SNA_CROSS_CONSULTING_GROUP],
                value: DeloitteOfferingApi.SNA_CROSS_CONSULTING_GROUP,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.SNA_HYBRID_SOLUTIONS_AND_INCUBATION],
                value: DeloitteOfferingApi.SNA_HYBRID_SOLUTIONS_AND_INCUBATION,
            },
            {
                displayText: DELOITTE_OFFERING_DISPLAY_NAME_MAP[DeloitteOfferingApi.SNA_STRATEGY],
                value: DeloitteOfferingApi.SNA_STRATEGY,
            },
        ],
    },
];
